import { IconButton } from "@mui/material";
import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import "../styles/backButton.css";

const BackButton = ({ onBack }) => {
  return (
    <IconButton
      onClick={onBack}
      sx={{
        transition: "all 0.4s linear",
        color: (theme) => theme.palette.primary.dark,
        "&:hover": {
          backgroundColor: (theme) => theme.palette.primary.dark,
          color: (theme) => theme.palette.primary.light,
        },
      }}
    >
      <IoMdArrowRoundBack />
    </IconButton>
  );
};

export default BackButton;
